import { useEffect, useMemo, useState } from 'react';
import { useEvent } from '../hooks';
import { parseJson } from '../utils/parseJson';
const filterQueryParam = 'filter';
export const useRowFilterCondition = (setQueryParam, getQueryParam, fixedFilterCondition) => {
    const queryParamValue = parseJson(getQueryParam(filterQueryParam));
    const [condition, setCondition] = useState({
        andConditions: [...(fixedFilterCondition?.andConditions ?? []), ...(queryParamValue?.andConditions ?? [])],
        maxRecords: queryParamValue?.maxRecords,
    });
    const setConditionCallback = useEvent((updater) => {
        if (typeof updater === 'function') {
            const nextCondition = updater(condition);
            setCondition(nextCondition);
            return;
        }
        const filteredCondition = {
            ...updater,
            andConditions: updater?.andConditions?.filter((c) => !c.fixed) ?? [],
        };
        setCondition(filteredCondition);
    });
    useEffect(() => {
        const filteredCondition = {
            ...condition,
            andConditions: condition?.andConditions?.filter((c) => !c.fixed) ?? [],
        };
        setQueryParam(filterQueryParam, JSON.stringify(filteredCondition));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [condition]);
    return useMemo(() => [condition, setConditionCallback], [condition, setConditionCallback]);
};
//# sourceMappingURL=useRowFilterCondition.js.map